<form [formGroup]="formGroup" class="d-flex flex-lg-row flex-column gap-2 px-3">
  <div class="input-group">
    <div class=" col-lg-12">
      <ncp-switch [(options)]="vaccineSwitchOptions" />
    </div>
    <div class="col-12">
      @if(isChecked) {
        <ncp-input #searchInput [(options)]='brandNameInputOptions' />
      } @else {
        <ncp-input #searchInput [(options)]='descriptionInputOptions' />
      }
      </div>
  </div>
</form>
